export const roomTemplate = () => ({
  name: '',
  size: {
    length: '',
    width: '',
    height: '',
  },
  ceiling: {
    damaged: '',
    type: '',
    files: []
  },
  walls: {
    damaged: '',
    types: {
      oboi_bumazhnie: false,
      oboi_vinilovie: false,
      oboi_pod_pokrasku: false,
      oboi_tkanevye: false,
      okraska: false,
      venicianskaya_shtukaturka: false,
      derevyannie_paneli: false,
      gipsokarton: false,
      plitka: false,
      plastikovie_paneli: false,
      drugoe: false
    },
    files: []
  },
  floor: {
    damaged: '',
    type: '',
    files: []
  },
  doors: {
    damaged: '',
    type: '',
    files: []
  },
  windows: {
    damaged: '',
    type: '',
    files: []
  },
})


export const movingTemplate = () => ({
  name: '',
  description: '',
  current_cost: '',
  year_of_purchase: '',
  files: []
})

export const engineerTemplate = () => (
  {
    name: '',
    descr: ''
  })